export class LqdAnimatedBlobHandler extends elementorModules.frontend.handlers.Base {

  onInit(...args) {

    super.onInit(...args);

    this.handleDestroy();

    this.initAnimatedBlob();

  }

  getDefaultSettings() {
    return {
      selectors: {
        animatedBlobElement: '[data-lqd-animated-blob]',
      }
    }
  }

  getDefaultElements() {
    const selectors = this.getSettings('selectors');
    return {
      $animatedBlobElement: this.$element.find(selectors.animatedBlobElement),
    }
  }

  initAnimatedBlob() {

    this.elements.$animatedBlobElement.liquidAnimatedBlob();

  }

  onDestroy() {

    this.handleDestroy();

    super.onDestroy();

  }

  handleDestroy() {

    this.handleAnimatedBlobDestroy();

  }

  handleAnimatedBlobDestroy() {

    if ( ! this.elements.$animatedBlobElement.length ) return;

    const animatedBlobData = this.elements.$animatedBlobElement.data('plugin_liquidAnimatedBlob');

    if ( animatedBlobData ) {
      animatedBlobData.destroy();
    }

  }
  
}

export default ($element) => {
  elementorFrontend.elementsHandler.addHandler( LqdAnimatedBlobHandler, { $element } );
};